module.exports = __webpack_public_path__ + "static/img/img-features-feature-5-i-pad@2x.b9d35aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-5-i-pad@2x.png
// module id = 9Kdh
// module chunks = 18